import React, { useState, useEffect } from 'react'
import StepItem from '../../molecules/StepItem/StepItem'
import { Formik } from 'formik'
import DatiPersonali from './steps/DatiPersonali/DatiPersonali'
import Credenziali from './steps/Credenziali/Credenziali'
import DatiAziendali from './steps/DatiAziendali/DatiAziendali'
import InfoAggiuntive from './steps/InfoAggiuntive/InfoAggiuntive'
import Autorizzazioni from './steps/Autorizzazioni/Autorizazzioni'
import { getValidationSchema, getValidationSchemaAdmin } from './validationSchema'
import Button from '../../atoms/Button/Button'
import { api } from '../../../utils/index'
import { useRouter } from 'next/router'
import { REGISTRAZIONE, REGISTRAZIONECHECK, REGISTRAZIONEADMINAA } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import usePrivacy from '../../../hooks/usePrivacy'
import { useSelector } from 'react-redux'
import { trackingRegistrazioneFunnel } from '../../../utils/gtm'

const FormRegistrazione = ({ admin_template = false, codice = null }) => {
  //admin_template se arriva da mail per registrare nuovo utente admin_aa

  const { service_gift } = useSelector((state) => state?.servicegift)
  const router = useRouter()
  const t = useTrans()

  const [errors, setErrors] = useState([])
  const [step, setStep] = useState(0)
  const validationSchema = !admin_template ? getValidationSchema() : getValidationSchemaAdmin()

  useEffect(() => {
    setErrors([])
  }, [step])

  const _postPayload = async (values) => {
    if (admin_template) {
      const params = {
        utente: {
          nome: values.utente.nome,
          cognome: values.utente.cognome,
          email: values.utente.email,
          telefono: values.utente.telefono,
          username: values.credenziali.username,
          password: values.credenziali.password, //in Questo caso non sarebbe meglio creare un jwt con tutto il payload? e fare il decode lato backend?
          privacy: values.autorizzazioni.privacy,
          privacy_commerciale: values.autorizzazioni.privacy_commerciale,
        },
        anagrafica_codice: codice,
      }
      await api.post(REGISTRAZIONEADMINAA, params).catch((err) => console.log(err))
    } else {
      const params = {
        utente: {
          nome: values.utente.nome,
          cognome: values.utente.cognome,
          email: values.utente.email,
          telefono: values.utente.telefono,
          username: values.credenziali.username,
          password: values.credenziali.password, //in Questo caso non sarebbe meglio creare un jwt con tutto il payload? e fare il decode lato backend?
          privacy: values.autorizzazioni.privacy,
          privacy_commerciale: values.autorizzazioni.privacy_commerciale,
        },
        anagrafica: {
          ragione_sociale: values.dati_aziendali.ragione_sociale,
          partita_iva: values.dati_aziendali.partita_iva,
          sottocanale_commerciale_id: values.info_aggiuntive?.sottocanale_commerciale_id,
        },
        indirizzo: {
          nazione_id: values.dati_aziendali.nazione_id,
          indirizzo: values.dati_aziendali.indirizzo,
          email: values.dati_aziendali.email,
          cap: values.dati_aziendali.cap,
          citta: values.dati_aziendali.citta,
          provincia: values.dati_aziendali?.provincia,
          telefono: values.dati_aziendali.telefono,
        },
      }
      await api
        .post(REGISTRAZIONE + '?lang=' + router.locale, params)
        .catch((err) => console.log(err))
    }
  }
  const RenderStep = ({ props }) => {
    const t = useTrans()
    const { getUrlCondizioniGenerali } = usePrivacy()
    return (
      <>
        <StepItem
          stepNumber={1}
          placeholder={t('Dati personali')}
          setStep={setStep}
          Modificabile={step > 0 ? true : false}
          isDisabled={step < 0 ? true : false}
          open={step === 0 ? true : false}
        >
          <DatiPersonali step={step} setStep={setStep} props={props} />
        </StepItem>
        <StepItem
          setStep={setStep}
          Modificabile={step > 1 ? true : false}
          isDisabled={step < 1 ? true : false}
          open={step === 1 ? true : false}
          stepNumber={2}
          placeholder={t('Credenziali di accesso')}
        >
          <Credenziali step={step} setStep={setStep} props={props} />
        </StepItem>
        {!admin_template && (
          <StepItem
            setStep={setStep}
            Modificabile={step > 2 ? true : false}
            isDisabled={step < 2 ? true : false}
            open={step === 2 ? true : false}
            stepNumber={3}
            placeholder={t('Dati aziendali')}
          >
            <DatiAziendali step={step} setStep={setStep} props={props} />
          </StepItem>
        )}
        {!admin_template && (
          <StepItem
            setStep={setStep}
            Modificabile={step > 3 ? true : false}
            isDisabled={step < 3 ? true : false}
            open={step === 3 ? true : false}
            stepNumber={4}
            placeholder={t('Info Aggiuntive')}
          >
            <InfoAggiuntive step={step} setStep={setStep} props={props} />
          </StepItem>
        )}
        <StepItem
          setStep={setStep}
          Modificabile={step > (admin_template ? 2 : 4) ? true : false}
          isDisabled={step < (admin_template ? 2 : 4) ? true : false}
          open={step === (admin_template ? 2 : 4) ? true : false}
          stepNumber={admin_template ? 3 : 5}
          placeholder={t('Autorizzazioni e consensi')}
        >
          <Autorizzazioni
            getUrlCondizioniGenerali={getUrlCondizioniGenerali}
            step={step}
            setStep={setStep}
            props={props}
          />
        </StepItem>
      </>
    )
  }

  const handleEmailPiva = async (data, values) => {
    const { exists_email, exists_piva, exists_username } = data

    setErrors([
      ...(exists_email ? [t('Esiste già un account con la stessa Email')] : []),
      ...(exists_piva ? [t('Esiste già un account con la stessa Partita Iva')] : []),
      ...(exists_username ? [t('Esiste già un account lo username indicato')] : []),
    ])

    !exists_email &&
      !exists_username &&
      !exists_piva &&
      (await _postPayload(values)
        .then(router.push('/myaccount/registrazione/completed'))
        .catch((err) => console.log(err)))
  }

  if (service_gift) {
    return null
  }

  return (
    <Formik
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={validationSchema}
      isInitialValid={false}
      initialValues={{
        utente: {
          email: null,
          nome: null,
          cognome: null,
          telefono: null,
        },
        credenziali: {
          username: null,
          password: null,
          conferma_password: null,
        },
        autorizzazioni: {
          privacy: false,
          privacy_commerciale: false,
        },
        dati_aziendali: {
          withProvincia: false,
        },
      }}
      onSubmit={(values) => {
        try {
          const params = {
            username: values.credenziali.username,
            email: values.utente.email,
            partita_iva: values.dati_aziendali.partita_iva,
            nazione_id: values.dati_aziendali.nazione_id,
            admin_template: admin_template,
          }
          api
            .get(REGISTRAZIONECHECK, { params })
            .then((res) => {
              setErrors([])
              handleEmailPiva(res.data, values)
            })
            .catch((error) => console.log(error, 'error p.iva'))
        } catch (error) {
          console.log(error)
        }
      }}
    >
      {(props) => (
        <>
          <RenderStep props={props} />
          <>
            {errors.map((erorr, index) => (
              <div
                style={{ color: 'red', fontSize: 14, marginTop: 10, marginBottom: 10 }}
                key={index + '_error'}
              >
                <p>{erorr}</p>
              </div>
            ))}
          </>
          {step > (admin_template ? 2 : 4) &&
            props.isValid &&
            (errors.length ? (
              <Button
                type="submit"
                onClick={() => router.push('/myaccount/recupera-password')}
                label={t('Recupera Password')}
                size="medium"
                // variant="primary"
                className="registrazione__template__submit"
              />
            ) : (
              <Button
                type="submit"
                disabled={!props.isValid}
                onClick={() => {
                  trackingRegistrazioneFunnel(6)
                  props.handleSubmit()
                }}
                label={t('Conferma registrazione')}
                size="medium"
                variant="primary"
                className="registrazione__template__submit"
              />
            ))}
        </>
      )}
    </Formik>
  )
}

export default FormRegistrazione
